import { render, staticRenderFns } from "./IOSSNumbersShow.vue?vue&type=template&id=3b4e8660&scoped=true"
import script from "./IOSSNumbersShow.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e8660",
  null
  
)

export default component.exports